import { SignUpButton } from "@clerk/clerk-react";
import { Button } from "@/components/ui/button";
import { SlideIn, FadeIn, StaggerContainer, StaggerItem } from "@/components/motion";

const stats = [
  { label: "Verified Experts", value: "100%" },
  { label: "Platform Fees for Early Members", value: "$0" },
  { label: "Community Support", value: "24/7" },
  { label: "Genius Acceptance Rate", value: "3%" },
];

export function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-[#F8FAFC] px-6 sm:px-10 lg:px-16 xl:px-20 2k:px-80 py-16 sm:py-20 lg:py-24">
      <div className="mx-auto grid gap-12 lg:grid-cols-2 lg:items-center">
        <div className="order-2 space-y-8 lg:order-1 my-4">
          <SlideIn direction="up" delay={0.1}>
            <div className="inline-flex items-center rounded-pill px-6 py-3 bg-white border border-[#E2E8F0] shadow-sm gap-2">
              <div className="w-2 h-2 bg-[#10B981] rounded-full"></div>
              <span className="text-[14px] font-semibold text-[#AAAAAA]">Building the future of AI consulting</span>
            </div>
          </SlideIn>
          <div className="space-y-3">
            <SlideIn direction="up" delay={0.2}>
              <h1 className="text-4xl font-extrabold tracking-tight text-[#2D3B54] sm:text-5xl lg:text-6xl">
                We Don&apos;t Just Vet.
                <span className="block text-[#2b42a3]">
                  We Nurture Excellence.
                </span>
              </h1>
            </SlideIn>
            <SlideIn direction="up" delay={0.3}>
              <p className="text-lg leading-relaxed text-[#475569]">
                Join the top 3% of AI experts who receive ongoing training from
                Mark Kashef and industry leaders. We&apos;re building careers, not
                just filling gigs. Make your first AI dollar with a community that
                has your back.
              </p>
            </SlideIn>
          </div>
          <SlideIn direction="up" delay={0.4}>
            <div className="flex flex-wrap gap-4">
              <SignUpButton mode="modal">
                <Button className="rounded-pill bg-[#4669ed] px-12 py-5 text-base font-semibold text-white hover:bg-[#2b42a3]">
                  Hire AI Experts
                </Button>
              </SignUpButton>
              <SignUpButton mode="modal">
                <Button
                  variant="outline"
                  className="rounded-pill border-2 border-slate-200 bg-white px-12 py-5 text-base font-semibold text-[#4669ed]"
                >
                  Apply as an Expert
                </Button>
              </SignUpButton>
            </div>
          </SlideIn>
        </div>
        <FadeIn delay={0.3} className="order-1 lg:order-2">
          <div className="relative mx-auto max-w-xl">
            <img
              src="/hero_r_image.svg"
              alt="AI Expert Network talent"
              className="h-full w-full rounded-[2.5rem] object-cover"
              loading="lazy"
            />
            <div className="pointer-events-none absolute inset-0 rounded-[2.5rem] border border-white/30" />
          </div>
        </FadeIn>
      </div>
      <StaggerContainer staggerDelay={0.08} delayChildren={0.5} className="rounded-2xl sm:rounded-pill bg-white px-4 sm:px-6 lg:px-10 py-6 sm:py-8 m-auto shadow-md grid gap-4 sm:gap-6 lg:gap-8 grid-cols-2 sm:grid-cols-4 text-center mt-8 sm:mt-0">
        {stats.map((stat) => (
          <StaggerItem key={stat.label}>
            <p className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#2D3B54] mb-1 sm:mb-2">
              {stat.value}
            </p>
            <p className="text-xs sm:text-sm font-semibold text-[#64748B]">{stat.label}</p>
          </StaggerItem>
        ))}
      </StaggerContainer>
    </section>
  );
}
